var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#639250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386224"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(-1830 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(1831 8)",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16",
    "data-name": "Shape 16",
    d: "M1844,37.132a8.7,8.7,0,0,1,.609-3.247,4.541,4.541,0,0,1,3.924-2.237h7.933a4.541,4.541,0,0,1,3.924,2.237,4.34,4.34,0,0,1,.609,2.247V38l-1.573-.156v-.757A3.046,3.046,0,0,0,1859,35.5a3.207,3.207,0,0,0-1.163-1.151,3.133,3.133,0,0,0-1.6-.426h-7.46a3.133,3.133,0,0,0-1.6.426A3.205,3.205,0,0,0,1846,35.5a3.046,3.046,0,0,0-.431,1.585v.757L1844,38Zm6.134-8.422a4.758,4.758,0,0,1-1.719-1.7,4.612,4.612,0,0,1,0-4.68,4.758,4.758,0,0,1,1.719-1.7,4.753,4.753,0,0,1,4.732,0,4.761,4.761,0,0,1,1.719,1.7,4.612,4.612,0,0,1,0,4.68,4.759,4.759,0,0,1-1.719,1.7,4.753,4.753,0,0,1-4.732,0Zm3.872-1.467a2.974,2.974,0,0,0,1.1-1.083,2.953,2.953,0,0,0,0-2.979,3.021,3.021,0,0,0-5.2,0,2.953,2.953,0,0,0,0,2.979,3.03,3.03,0,0,0,4.108,1.083Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2827",
    "data-name": "Ellipse 2827",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(1849 21)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.954afa8797422defd24cb9d664f7d04d.svg";
export { ForwardRef as ReactComponent };